import { SystemPromptApi, SystemPromptItemDto } from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { SystemPromptApiService } from "../ApiServices/SystemPromptApiService";
import GenericService from "../GenericService";

export class SystemPromptService extends GenericService<SystemPromptApi, SystemPromptApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, SystemPromptApi, SystemPromptApiService);
  }

  public getSystemPrompt(): Promise<SystemPromptItemDto | null | undefined> {
    return this.apiService.systemPromptGet();
  }

  public putSystemPrompt(systemPrompt: string): Promise<SystemPromptItemDto> {
    return this.apiService.systemPromptPut({ systemPromptItemDto: { systemPrompt } });
  }

  public deleteSystemPrompt(): Promise<string> {
    return this.apiService.deleteSystemPrompt();
  }
}
